import React from "react";
import { Field } from "react-final-form";
import RffInputWrapper from "../shared/RffInputWrapper";
import PercentInput from "../../inputs/PercentInput";

const RffPercentField = ({
  name,
  label,
  required = false,
  helperText,
  placeholder,
  fullWidth = true,
  row = false,
  suppressGrid,
  size,
  disabled,
  onBlur,
}) => (
  <RffInputWrapper
    label={label}
    suppressGrid={suppressGrid}
    size={size}
    helperText={helperText}
    required={required}
    row={row}
  >
    <Field
      name={name}
      validate={(v) =>
        required && (v == null || v === "") ? "This field is required" : undefined
      }
      parse={(v) => (v === "" ? undefined : v)}
      render={({ input, meta }) => (
        <PercentInput
          {...input}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          fullWidth={fullWidth}
          error={meta.touched && !!meta.error}
          helperText={meta.touched && meta.error ? meta.error : null}
        />
      )}
    />
  </RffInputWrapper>
);

export default RffPercentField;
